// Lazily-enumerate every public component (`*.vue` under
// `applications/*/public/components/*`) so we can match the requested
// component case-insensitively. This makes the resolver resilient to browsers/
// keyboards/autocomplete that may alter the URL casing (e.g. lowercase it),
// since folder/file names on the filesystem are case-sensitive.
const publicComponents = require.context('../../../../applications', true, /public\/components\/.+\.vue$/, 'lazy')

export default {
  name: 'ComponentResolverPublic',

  props: {
    componentId: String,
    forwardRef: Function,
    componentProps: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    resolvedComponent: ''
  }),

  created: async function () {
    const resolvedComponent = await this.resolveComponent(this.$route)
    this.resolvedComponent = resolvedComponent.default
  },
  methods: {
    async resolveComponent (route) {
      const segments = route.path.split('/').filter(Boolean)
      const [base, applicationId, ...trackerId] = segments
      const fileName = trackerId.pop() // Takes the last segment as the file name

      if (base !== 'application' || !applicationId || !fileName) return null

      try {
        const expectedKey = `./${applicationId}/public/components/${fileName}/${fileName}.vue`.toLowerCase()
        const matchedKey = publicComponents.keys().find(key => key.toLowerCase() === expectedKey)

        if (!matchedKey) {
          throw new Error(`Nessun componente pubblico trovato per '${applicationId}/${fileName}'`)
        }

        return await publicComponents(matchedKey)
      } catch (error) {
        console.error(`Impossibile trovare il componente: ${error}`)
        // eslint-disable-next-line no-return-await
        return await import(`@/agilis/public/components/NotFound/NotFound.vue`)
      }
    }

  }
}
